import { observable } from "mobx";
import { Type } from "class-transformer";
import ReadingListReadingsItem from "./readingListReadingsItem";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ReadingList {
  @observable
  total!: number;

  @observable
  @Type(() => ReadingListReadingsItem)
  readings!: ReadingListReadingsItem[];

  static ValidationRules = {
    total: { required: true, number: true },
    readings: { required: true },
  };
}
